import { setBackgroundColor } from "./features/color-adjustments/backgroundColor";
import { setTextColor } from "./features/color-adjustments/textColor";
import { setLetterSpacing } from "./features/content-adjustments/letterSpacing";
import { setWordSpacing } from "./features/content-adjustments/wordSpacing";
import { setLineSpacing } from "./features/content-adjustments/lineSpacing";

export function applyBackgroundColor(color: string) {
  setBackgroundColor(color);
}

export function applyTextColor(color: string) {
  setTextColor(color);
}

export function applyLetterSpacing(value: number) {
  setLetterSpacing(value);
}

export function applyWordSpacing(value: number) {
  setWordSpacing(value);
}

export function applyLineSpacing(value: number) {
  setLineSpacing(value);
}
